import oidcManager from "./oidc-manager"

export default {
  signInRedirect(returnPath, params = {}) {
    const opts = { extraQueryParams: { ...params } };
    if (returnPath) {
      opts.state = returnPath;
    }
    return oidcManager.instance.signinRedirect(opts);
  },
  signOutRedirect(showLogoutPrompt = null) {
    const extraQueryParams = {};

    if (showLogoutPrompt) {
      extraQueryParams.show_logout_prompt = !!showLogoutPrompt
    }

    return oidcManager.instance.signoutRedirect({ extraQueryParams })
  },
  signInCallback() {
    return oidcManager.instance.signinRedirectCallback()
  },
  signOutCallback() {
    return oidcManager.instance.signoutRedirectCallback()
  },
  signInSilent() {
    return oidcManager.instance.signinSilent()
  },
  signInPopup() {
    return oidcManager.instance.signinPopup()
  },
  clearStaleState() {
    oidcManager.instance.clearStaleState();
  },
  async getOidcManager() {
    try {
      return oidcManager.instance
    } catch (e) {
      const manager = await oidcManager.waitConfigure()
      return manager
    }
  },
  async getIdentityUser() {
    const user = await (await this.getOidcManager()).getUser()
    return user
  },
  async getAccessToken() {
    const identityUser = await this.getIdentityUser()
    return identityUser ? identityUser.access_token : null
  },
  async getUserId() {
    const identityUser = await this.getIdentityUser()
    return identityUser && identityUser.profile ? identityUser.profile.sub : null
  }
}
